module.exports = __webpack_public_path__ + "static/media/Affe.cf6aa1cb.png";